// extracted by mini-css-extract-plugin
export default {"waikawaGray":"#666","black":"#000","bodyContainer":"styles_bodyContainer__b4Tns","sectionContainer":"styles_sectionContainer__3psxq"};